




























import Vue from 'vue'
import Component from 'vue-class-component'
import BraintreeDropin from 'braintree-web-drop-in'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import DropinContainer from './DropinContainer.vue'
import { ClientsidePaymentMethod } from '@/models/payment/PaymentMethods'

@Component({
    refs: ['dropinContainer'],
    components:
    {
        DropinContainer
    },
    recomputed:
    {
        paymentMethodReady()
        {
            const _this = this as PaymentMethodSelect;
            if (_this.dropin)
            {
                return _this.dropin.isPaymentMethodRequestable();
            }
            return false;
        }
    }
})
export default class PaymentMethodSelect extends Vue
{
    @Prop(Boolean) readonly hideButton! : Boolean; // default false

    dropinKey = 0
    creatingNew = false
    loading = false
    methods : ClientsidePaymentMethod[] = []
    selectedPaymentMethod : object | null = null

    get creatingPaymentMethod()
    {
        if (this.methods.length > 0)
        {
            return true;
        }
        
        const dropin = this.dropin;
        if (!dropin) return false;
    }

    get dropinContainer() : DropinContainer | null
    {
        if (!this.$refs.dropinContainer) return null;
        return this.$refs.dropinContainer as (DropinContainer);
    }

    get dropin() : BraintreeDropin.Dropin | null | undefined
    {
        if (!this.dropinContainer) return null;
        return this.dropinContainer.dropin;
    }

    async addPaymentMethod()
    {
        const dropin = this.dropin;
        if (!dropin) return;

        const method = await dropin.requestPaymentMethod();
        try
        {
            await this.$http.post('payments/customer/methods', {none: method.nonce});
            //++this.dropinKey;
        }
        catch(er)
        {
            // TODO: Proper error handling
            console.error(er);
            alert(er);
        }
    }

    async onMethodChange(valid : boolean)
    {
        this.$recompute('paymentMethodReady');
        if (this.hideButton)
        {
            this.selectPaymentMethod();
        }
    }

    async selectPaymentMethod() : Promise<any>
    {
        const dropin = this.dropin;
        if (!dropin) return;

        const method = await dropin.requestPaymentMethod();
        this.$emit('payment-method-selected', method);
        return method;
    }

    async loadPaymentMethods()
    {
        this.loading = true;
        try
        {
            const resp = await this.$http.get<{ methods : ClientsidePaymentMethod [] }>('payments/customer/methods');
            this.methods.length = 0;
            for (const method of resp.data.methods)
            {
                this.methods.push(Object.assign(new ClientsidePaymentMethod, method));
            }
        }
        catch(er)
        {
            // TODO: Proper error handling
            console.error(er);
            alert(er);
        }
        this.loading = false;
    }

    mounted()
    {
        //this.loadPaymentMethods();
    }
}
